<div class="condition-editor">

  <div class="condition-row">
    <div class="leftMargin">
      <div class="topLeft"></div>
      <div class="bottomLeft"></div>
      <div class="my-operator {{type}}" *ngIf="!first">{{operator}}</div>
    </div>
    <div class="my-header">
      <div class="title"></div>
      <div class="title"></div>
    </div>
  </div>

  <div class="condition-row">
    <div class="leftMargin">
      <div class="topLeft"></div>
      <div class="topRight"></div>
      <div class="bottomLeft"></div>
    </div>

    <div class="icons-list-button">
      <div class="top-icons">
        <i class="fa fa-trash" (click)="onDeleteMe()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Delete'"></i>
        <i class="fa fa-clone" (click)="onCloneMe()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Clone'"></i>
        <i class="fa fa-bars" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Drag to change priority'"></i>
      </div>
      <div class="factor-list" [dragula]=listName [dragulaModel]="condition.factors">
        <gen-factor-editor *ngFor="let factor of condition.factors"
                           [factor]="factor"
                           (deleteMe)="deleteFactor($event)"
                           (cloneMe)="duplicateFactor($event)">
        </gen-factor-editor>
        <div class="add-factor" (click)="addFactor()">
          Add Condition
        </div>
      </div>
    </div>
  </div>
</div>
